import { Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
	selector: "app-topbar-user-profile-menu-item",
	imports: [MatIcon],
	templateUrl: "./topbar-user-profile-menu-item.component.html",
})
export class TopbarUserProfileMenuItemComponent {
	route = input<string>();
	icon = input<string>();
}
